import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { AfectacionesVentaConstant } from 'constants/index'

const DefectoAfectacionVentasFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label
        text='DEF AFECT VENTAS'
        htmlFor='select-defectoAfectacionVentas'
        md={4}
        alignRightAt='md'
      />
      <Col md={8}>
        <Field name='defectoAfectacionVentas'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-defectoAfectacionVentas'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            >
              <option value=''>Seleccionar</option>
              {AfectacionesVentaConstant.__array.map((x, k) => (
                <option key={k} value={x.id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(DefectoAfectacionVentasFormGroup)
